import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import { formatLocation } from "../utils/locations";
import { ModalShell } from "./ModalShell";

export function ActionModal({
  location,
  onClose,
  onDropped,
  onNote,
  onPartial,
  onRemove,
}) {
  return (
    <ModalShell
      icon={<LocationOnIcon />}
      title={`Location ${formatLocation(location)}`}
      subtitle={location.item_name}
      onClose={onClose}
    >
      <p className="helper-text">Choose an action for this location.</p>
      <div className="action-grid">
        <button type="button" className="action-button dropped" onClick={onDropped}>
          <ArrowDownwardIcon className="action-icon" />
          {location.is_dropped ? "CLEAR DROPPED" : "DROPPED"}
        </button>
        <button type="button" className="action-button partial" onClick={onPartial}>
          <Inventory2OutlinedIcon className="action-icon" />
          PARTIAL ({location.partial_count || "X"})
        </button>
        <button type="button" className="action-button remove" onClick={onRemove}>
          <DeleteOutlineIcon className="action-icon" />
          REMOVE
        </button>
        <button type="button" className="action-button note" onClick={onNote}>
          <NoteAltIcon className="action-icon" />
          NOTE
        </button>
      </div>
      {location.note && (
        <div className="note-preview">
          <strong>Note preview</strong>
          <p>{location.note}</p>
        </div>
      )}
    </ModalShell>
  );
}
